import script from "./BusinessModuleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessModuleEditor.vue?vue&type=script&setup=true&lang=js"

import "./BusinessModuleEditor.vue?vue&type=style&index=0&id=01e74e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e74e3e"]])

export default __exports__